import React  from "react";
import { Typography, Grid, Container } from "@mui/material";
const Report = () => {
  return (
    <Container maxWidth="lg" sx={{ mt: 11, ml: 3 }}>
      <Grid container spacing={2} sx={{ px: 0, mb: 2 }} display="flex">
        <Grid item xs={3} md={3}>
          <Typography
            align="left"
            sx={{ mr: "auto", color: "#003f93", mb: 3 }}
            variant="h6">
            Report
          </Typography>
        </Grid>
      </Grid>
     
    </Container>
  );
};

export default Report;
